import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import AppsStorePage from '../../features/apps/components/AppsStorePage';

const AppsStorePageRoute = () => {
  return (
    <ProtectedRoute requiresAuth={true}>
      <AppsStorePage />
    </ProtectedRoute>
  );
};

export default AppsStorePageRoute;
